import { getDateFromStringWithoutTime } from '@/lib/date'

const mapperFormationToForm = formation => {
    const {
        id,
        course,
        situation,
        institution,
        conclusion,
        academic_formation,
    } = formation

    return {
        id,
        course,
        situation: {
            label: situation,
            value: situation,
        },
        institution,
        conclusion: getDateFromStringWithoutTime(conclusion, 'YYYY-MM-DD'),
        academicFormation: {
            label: academic_formation,
            value: academic_formation,
        },
    }
}

export { mapperFormationToForm }
